import { render, staticRenderFns } from "./cgwReviewer.vue?vue&type=template&id=6d818b8f&scoped=true&"
import script from "./cgwReviewer.vue?vue&type=script&lang=js&"
export * from "./cgwReviewer.vue?vue&type=script&lang=js&"
import style0 from "./cgwReviewer.vue?vue&type=style&index=0&id=6d818b8f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d818b8f",
  null
  
)

export default component.exports